export default "/biometrie-afghanistan/media/a885fa205f446b17e80bd92e4d369413~header-480w.jpg";